/** Manutenzioni Programmate · Rubrica Emergenze · Mobile FO */
import React from 'react';
import { Calendar, ChevronLeft, ChevronRight, Repeat, Wrench, UserCog,
  Archive, CheckCircle2, Building2, Siren, Phone, MessageCircle, Crown,
  Plus, AlertOctagon, Bell, Home, ListChecks, Sparkles } from 'lucide-react';
import { C, fontHead, overline, primaryBtn, secondaryBtn } from '../_tokens';

// =============================================================================
// SCREEN: Manutenzioni Programmate
// =============================================================================
export function ScreenScheduled() {
  return (
    <div style={{ padding: '32px 36px', background: C.bg, color: C.text, fontFamily: 'Inter', minHeight: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 26 }}>
        <div>
          <div style={{ ...overline, marginBottom: 6 }}>Predictive Maintenance</div>
          <h1 style={{ fontFamily: fontHead, fontSize: 38, fontWeight: 600, margin: 0,
                       letterSpacing: '-0.025em', lineHeight: 1 }}>
            Manutenzioni Programmate
          </h1>
          <div style={{ color: C.textSec, fontSize: 13, marginTop: 8 }}>
            28 attive · 4 in scadenza · 2 da assegnare
          </div>
        </div>
        <button style={{ ...primaryBtn }}><Plus size={14} /> Nuova manutenzione</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1.3fr 1fr', gap: 16, marginBottom: 16 }}>
        {/* CALENDAR */}
        <div style={{ background: C.surf, borderRadius: 20, padding: 24, border: `1px solid ${C.border}` }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
            <div>
              <div style={{ fontFamily: fontHead, fontSize: 22, fontWeight: 600 }}>Giugno 2026</div>
              <div style={{ fontSize: 11.5, color: C.textSec, marginTop: 2 }}>9 manutenzioni schedulate</div>
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              <button style={navBtn}><ChevronLeft size={14} /></button>
              <button style={{ ...navBtn, color: C.gold, borderColor: `${C.gold}55`, background: `${C.gold}11` }}>Oggi</button>
              <button style={navBtn}><ChevronRight size={14} /></button>
            </div>
          </div>
          <CalendarGrid />
        </div>

        {/* UPCOMING */}
        <div style={{ background: C.surf, borderRadius: 20, padding: 22, border: `1px solid ${C.border}` }}>
          <div style={{ marginBottom: 18 }}>
            <div style={{ fontFamily: fontHead, fontSize: 19, fontWeight: 600 }}>Prossime in scadenza</div>
            <div style={{ fontSize: 11.5, color: C.textSec, marginTop: 2 }}>Entro 30 giorni</div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {[
              { day: '12', month: 'GIU', title: 'Sanificazione ascensori', hotel: 'Galleria', tech: 'Luca M.', freq: 'Trimestrale', urgent: true },
              { day: '14', month: 'GIU', title: 'Pulizia filtri HVAC piano 1-3', hotel: 'Arcimboldi', tech: 'Marco T.', freq: 'Bimestrale' },
              { day: '20', month: 'GIU', title: 'Controllo estintori e luci emergenza', hotel: 'Scarlatti', tech: 'Sara K.', freq: 'Semestrale' },
              { day: '28', month: 'GIU', title: 'Sostituzione guarnizioni vasche idro', hotel: 'Kira', tech: 'Da assegnare', freq: 'Quadrimestrale' },
            ].map((m, i) => (
              <div key={i} style={{
                display: 'grid', gridTemplateColumns: '52px 1fr', gap: 14,
                padding: '12px 14px', borderRadius: 11,
                background: m.urgent ? `${C.terra}11` : 'rgba(255,255,255,0.02)',
                border: `1px solid ${m.urgent ? C.terra + '44' : C.border}`,
              }}>
                <div style={{
                  textAlign: 'center', padding: '6px 0', borderRadius: 8,
                  background: m.urgent ? C.terra : C.bg, color: m.urgent ? '#fff' : C.text,
                  boxShadow: m.urgent ? `0 0 18px ${C.terra}55` : 'none',
                }}>
                  <div style={{ fontFamily: fontHead, fontSize: 18, fontWeight: 700, lineHeight: 1 }}>{m.day}</div>
                  <div style={{ fontSize: 9, letterSpacing: '0.15em', marginTop: 2, opacity: 0.85 }}>{m.month}</div>
                </div>
                <div>
                  <div style={{ fontSize: 13.5, fontWeight: 600 }}>{m.title}</div>
                  <div style={{ fontSize: 11, color: C.textSec, marginTop: 4, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                      <Building2 size={10} /> {m.hotel}
                    </span>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                      <UserCog size={10} /> {m.tech}
                    </span>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, color: C.gold }}>
                      <Repeat size={10} /> {m.freq}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* HISTORY */}
      <div style={{ background: C.surf, borderRadius: 20, padding: 22, border: `1px solid ${C.border}` }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 36, height: 36, borderRadius: 9, background: `${C.emerald}22`,
                          display: 'grid', placeItems: 'center' }}>
              <Archive size={16} color={C.emerald} />
            </div>
            <div>
              <div style={{ fontFamily: fontHead, fontSize: 19, fontWeight: 600 }}>Storico Completate</div>
              <div style={{ fontSize: 11.5, color: C.textSec, marginTop: 2 }}>
                Manutenzioni eseguite · audit & controllo
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={{ ...secondaryBtn, padding: '8px 14px' }}>
              <Building2 size={12} /> Tutti gli hotel
            </button>
            <button style={{ ...secondaryBtn, padding: '8px 14px', color: C.gold, borderColor: `${C.gold}55` }}>
              Esporta PDF audit
            </button>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {[
            { h: 'Galleria · Milano', n: 4 },
            { h: 'Arcimboldi · Milano', n: 6 },
            { h: 'Scarlatti · Roma', n: 5 },
          ].map(group => (
            <div key={group.h}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 0' }}>
                <Building2 size={12} color={C.textSec} />
                <span style={{ ...overline }}>{group.h}</span>
                <span style={{ fontSize: 11, color: C.textDim }}>· {group.n}</span>
                <div style={{ flex: 1, height: 1, background: C.border, marginLeft: 10 }} />
              </div>
              <HistoryRow title="Sanificazione ascensori · cabina A+B" date="08 Giu 2026" tech="Luca M." progress="12/12" />
              <HistoryRow title="Pulizia filtri HVAC piano 1-3" date="01 Giu 2026" tech="Marco T." progress="8/8" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const navBtn = {
  width: 32, height: 32, borderRadius: 8, background: C.bg,
  border: `1px solid ${C.border}`, color: C.textSec,
  display: 'grid', placeItems: 'center', cursor: 'pointer', fontSize: 12,
  padding: 0,
};

const HistoryRow = ({ title, date, tech, progress }) => (
  <div style={{
    display: 'flex', alignItems: 'center', gap: 14,
    padding: '11px 14px', borderRadius: 10, marginBottom: 6,
    background: 'rgba(16,185,129,0.04)', border: `1px solid ${C.emerald}22`,
  }}>
    <CheckCircle2 size={16} color={C.emerald} />
    <div style={{ flex: 1 }}>
      <div style={{ fontSize: 13, fontWeight: 600 }}>{title}</div>
      <div style={{ fontSize: 11, color: C.textSec, marginTop: 3, display: 'flex', gap: 12 }}>
        <span>Eseguita: <b style={{ color: C.text }}>{date}</b></span>
        <span>· {tech}</span>
        <span style={{ color: C.emerald }}>· ✓ {progress}</span>
      </div>
    </div>
    <span style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: '0.08em',
                   padding: '4px 9px', borderRadius: 5,
                   background: C.emerald, color: '#fff' }}>COMPLETATA</span>
  </div>
);

const CalendarGrid = () => {
  const events = { 3: 'med', 8: 'low', 12: 'urg', 14: 'med', 18: 'low', 20: 'med', 24: 'low', 28: 'med' };
  const days = Array.from({ length: 35 }, (_, i) => i - 1); // -1, 0, 1 ... 33 → giu 2026 inizia di lun (1=giu1)
  const today = 11;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 4 }}>
      {['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'].map(d => (
        <div key={d} style={{ ...overline, textAlign: 'center', padding: '6px 0' }}>{d}</div>
      ))}
      {days.map(d => {
        const isCurrent = d >= 1 && d <= 30;
        const isToday = d === today;
        const ev = events[d];
        return (
          <div key={d} style={{
            aspectRatio: '1.1', padding: 6, borderRadius: 8,
            background: isToday ? `${C.gold}22` : isCurrent ? 'rgba(255,255,255,0.02)' : 'transparent',
            border: `1px solid ${isToday ? C.gold : C.border}`,
            opacity: isCurrent ? 1 : 0.3,
            display: 'flex', flexDirection: 'column',
          }}>
            <div style={{ fontSize: 11, fontWeight: isToday ? 700 : 500,
                          color: isToday ? C.gold : C.text, textAlign: 'right' }}>
              {isCurrent ? d : (d <= 0 ? 30 + d + 1 : d - 30)}
            </div>
            {ev && (
              <div style={{ flex: 1, display: 'flex', alignItems: 'flex-end' }}>
                <div style={{
                  height: 4, width: '100%', borderRadius: 2,
                  background: ev === 'urg' ? C.terra : ev === 'med' ? C.gold : C.cyan,
                  boxShadow: ev === 'urg' ? `0 0 6px ${C.terra}` : 'none',
                }} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

// =============================================================================
// SCREEN: Rubrica Emergenze
// =============================================================================
export function ScreenEmergencies() {
  return (
    <div style={{ padding: '32px 36px', background: C.bg, color: C.text, fontFamily: 'Inter', minHeight: '100%' }}>
      <div style={{ marginBottom: 24 }}>
        <div style={{ ...overline, color: C.terra, marginBottom: 6 }}>Emergency Operations</div>
        <h1 style={{ fontFamily: fontHead, fontSize: 38, fontWeight: 600, margin: 0,
                     letterSpacing: '-0.025em', lineHeight: 1 }}>
          Rubrica Emergenze
        </h1>
        <p style={{ color: C.textSec, fontSize: 14, marginTop: 12, maxWidth: 700 }}>
          Contatti di emergenza per intervento immediato. <b style={{ color: C.terra }}>Prima di chiamare</b>,
          informa sempre il responsabile di turno.
        </p>
      </div>

      {/* Responsible */}
      <div style={{
        padding: '20px 24px', borderRadius: 18,
        background: `linear-gradient(135deg, ${C.terra}22, transparent 70%), ${C.surf}`,
        border: `1px solid ${C.terra}55`, marginBottom: 24,
        display: 'flex', alignItems: 'center', gap: 18,
      }}>
        <div style={{
          width: 56, height: 56, borderRadius: 16,
          background: `linear-gradient(135deg, ${C.terra}, #C95A40)`,
          display: 'grid', placeItems: 'center',
          boxShadow: `0 0 32px ${C.terra}88`,
        }}><Crown size={26} color="#fff" /></div>
        <div style={{ flex: 1 }}>
          <div style={{ ...overline, color: C.terra, marginBottom: 4 }}>Responsabile di turno</div>
          <div style={{ fontFamily: fontHead, fontSize: 22, fontWeight: 600 }}>Marco Verdi</div>
          <div style={{ fontSize: 12, color: C.textSec, marginTop: 2 }}>
            Avvisalo PRIMA di chiamare qualsiasi fornitore in rubrica
          </div>
        </div>
        <button style={{
          background: '#fff', color: C.terra, border: 'none',
          padding: '12px 22px', borderRadius: 12, fontWeight: 700, fontSize: 14, cursor: 'pointer',
          display: 'inline-flex', alignItems: 'center', gap: 8,
        }}>
          <Phone size={15} /> +39 333 555 1234
        </button>
      </div>

      {/* Contacts grid */}
      <div style={{ ...overline, marginBottom: 14 }}>Contatti fornitori</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14 }}>
        {[
          { icon: '🔧', name: 'Idraulico Rossi SRL', cat: 'Idraulica · H24', phone: '+39 02 1112233', note: 'Contratto attivo · max 60 min', accent: C.cyan },
          { icon: '⚡', name: 'Elettricista Bianchi', cat: 'Elettrica · H24', phone: '+39 02 4445566', note: 'Reperibile anche notturno', wa: true, accent: C.gold },
          { icon: '🛗', name: 'Ascensori Schindler', cat: 'Ascensori · H24', phone: '+39 800 100200', note: 'Codice cliente CL-12345', accent: C.terra },
          { icon: '🔥', name: 'Caldaie Beretta', cat: 'Termoidraulica · Feriali 8-18', phone: '+39 02 7778899', note: 'Solo orario lavorativo', accent: C.amber },
          { icon: '🚨', name: 'Antincendio Securpro', cat: 'Sicurezza · H24', phone: '+39 800 555 911', note: 'Allarmi, estintori, sprinkler', accent: C.terra },
          { icon: '🛠️', name: 'Generica Manutenzioni', cat: 'Multiservizi · Feriali', phone: '+39 02 9990000', note: 'Backup per emergenze miste', accent: C.cyan },
        ].map((c, i) => (
          <div key={i} style={{
            background: C.surf, borderRadius: 16, padding: 20,
            border: `1px solid ${C.border}`, position: 'relative', overflow: 'hidden',
          }}>
            <div style={{
              position: 'absolute', top: 0, right: 0, width: 100, height: 100,
              background: `radial-gradient(circle at top right, ${c.accent}22, transparent 60%)`,
            }} />
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
              <div style={{
                width: 42, height: 42, borderRadius: 11, background: `${c.accent}1a`,
                display: 'grid', placeItems: 'center', fontSize: 20,
              }}>{c.icon}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{c.name}</div>
                <div style={{ fontSize: 11, color: C.textSec, marginTop: 2 }}>{c.cat}</div>
              </div>
            </div>
            <div style={{ fontSize: 12, color: C.textSec, marginBottom: 14, lineHeight: 1.4 }}>{c.note}</div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button style={{
                flex: 1, background: c.accent, color: '#fff', border: 'none',
                padding: '10px', borderRadius: 9, fontWeight: 600, fontSize: 13, cursor: 'pointer',
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
              }}>
                <Phone size={13} /> Chiama
              </button>
              {c.wa && (
                <button style={{
                  background: '#25D366', color: '#fff', border: 'none', padding: '10px 12px',
                  borderRadius: 9, cursor: 'pointer',
                }}><MessageCircle size={13} /></button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// =============================================================================
// SCREEN: Mobile Front Office (phone frame mockup)
// =============================================================================
export function ScreenMobileFO() {
  return (
    <div style={{
      padding: '40px 36px', background: `radial-gradient(ellipse at center, ${C.bgDeep}, ${C.bg})`,
      color: C.text, fontFamily: 'Inter', minHeight: '100%',
      display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: 60,
    }}>
      {/* Phone frame */}
      <div style={{
        width: 390, height: 800, borderRadius: 48,
        background: `linear-gradient(180deg, #1A1F2E, ${C.bgDeep})`,
        padding: 12, position: 'relative',
        boxShadow: `0 30px 80px rgba(0,0,0,0.6), 0 0 0 1px ${C.borderStrong}`,
      }}>
        <div style={{
          background: C.bg, borderRadius: 36, overflow: 'hidden',
          width: '100%', height: '100%', position: 'relative',
          backgroundImage: `radial-gradient(ellipse 80% 40% at 50% 0%, rgba(212,175,55,0.1), transparent)`,
        }}>
          {/* Notch */}
          <div style={{
            position: 'absolute', top: 8, left: '50%', transform: 'translateX(-50%)',
            width: 120, height: 26, background: '#000', borderRadius: 14, zIndex: 10,
          }} />

          {/* App header */}
          <div style={{ padding: '50px 18px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: 10, color: C.textSec, letterSpacing: '0.15em', textTransform: 'uppercase' }}>Galleria</div>
              <div style={{ fontFamily: fontHead, fontSize: 20, fontWeight: 600, marginTop: 2 }}>Ciao Marco</div>
            </div>
            <button style={{ position: 'relative', width: 36, height: 36, borderRadius: 10,
                            background: C.surf, border: `1px solid ${C.border}`,
                            display: 'grid', placeItems: 'center' }}>
              <Bell size={15} color={C.text} />
              <span style={{ position: 'absolute', top: 8, right: 8, width: 7, height: 7,
                            borderRadius: '50%', background: C.terra }} />
            </button>
          </div>

          {/* Hero stat */}
          <div style={{ margin: '0 18px', padding: 18, borderRadius: 18,
                        background: `linear-gradient(135deg, ${C.terra}33, ${C.terra}11)`,
                        border: `1px solid ${C.terra}55` }}>
            <div style={{ ...overline, color: C.terra, marginBottom: 6 }}>Ticket urgenti</div>
            <div style={{ fontFamily: fontHead, fontSize: 52, fontWeight: 600, lineHeight: 1, color: C.terra }}>3</div>
            <div style={{ fontSize: 11.5, color: C.textSec, marginTop: 4 }}>2 in scadenza SLA</div>
          </div>

          {/* Mini stats */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8, padding: '14px 18px' }}>
            {[['12', 'Aperti'], ['7', 'In lavoro'], ['18', 'Chiusi']].map(([n, l]) => (
              <div key={l} style={{
                background: C.surf, padding: '10px 12px', borderRadius: 12, border: `1px solid ${C.border}`,
              }}>
                <div style={{ fontFamily: fontHead, fontSize: 24, fontWeight: 600 }}>{n}</div>
                <div style={{ fontSize: 10, color: C.textSec, marginTop: 2 }}>{l}</div>
              </div>
            ))}
          </div>

          {/* Filters */}
          <div style={{ display: 'flex', gap: 6, padding: '6px 18px', overflowX: 'auto' }}>
            {['Tutti', 'Urgenti', 'In lavoro', 'Chiusi'].map((f, i) => (
              <button key={f} style={{
                padding: '6px 12px', borderRadius: 999, fontSize: 11, whiteSpace: 'nowrap',
                background: i === 1 ? `${C.terra}22` : C.surf,
                color: i === 1 ? C.terra : C.textSec, fontWeight: i === 1 ? 600 : 400,
                border: `1px solid ${i === 1 ? C.terra + '55' : C.border}`,
              }}>{f}</button>
            ))}
          </div>

          {/* Tickets */}
          <div style={{ padding: '10px 18px', display: 'flex', flexDirection: 'column', gap: 7, overflow: 'hidden', maxHeight: 320 }}>
            <MobileTicket prio={C.terra} room="Cam 208" cat="Idraulica" title="Perdita continua scarico" time="2m" />
            <MobileTicket prio={C.terra} room="Lobby" cat="HVAC" title="AC centrale spenta" time="14m" sla />
            <MobileTicket prio={C.amber} room="Cam 412" cat="Elettrica" title="Presa lato letto KO" time="42m" />
            <MobileTicket prio="#FBBF24" room="Cam 305" cat="Elettrodomestici" title="TV ingresso HDMI" time="1h" />
          </div>

          {/* Bottom nav */}
          <div style={{
            position: 'absolute', bottom: 14, left: 14, right: 14,
            background: C.surfGlass, backdropFilter: 'blur(24px)',
            border: `1px solid ${C.borderStrong}`, borderRadius: 22,
            padding: '10px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}>
            <NavBtn icon={Home} active />
            <NavBtn icon={ListChecks} />
            <button style={{
              width: 52, height: 52, borderRadius: '50%',
              background: `linear-gradient(135deg, ${C.gold}, ${C.goldDark})`,
              border: 'none', display: 'grid', placeItems: 'center',
              boxShadow: `0 0 28px ${C.gold}aa, 0 4px 12px rgba(0,0,0,0.3)`,
              marginTop: -28,
            }}><Plus size={22} color={C.bg} strokeWidth={2.5} /></button>
            <NavBtn icon={Siren} danger />
            <NavBtn icon={Sparkles} />
          </div>
        </div>
      </div>

      {/* Annotations panel */}
      <div style={{ maxWidth: 340, paddingTop: 60 }}>
        <div style={{ ...overline, color: C.gold, marginBottom: 12 }}>Mobile-first · Front Office</div>
        <h2 style={{ fontFamily: fontHead, fontSize: 30, fontWeight: 500, margin: 0,
                     letterSpacing: '-0.02em', lineHeight: 1.1 }}>
          Pensata per la mano.<br />
          <span style={{ color: C.gold }}>Non per il mouse.</span>
        </h2>
        <ul style={{ marginTop: 24, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 14 }}>
          <Bullet n="1" t="Hero numero gigante" b="Il dato che ti serve in 0,5 secondi mentre rispondi al telefono" />
          <Bullet n="2" t="FAB centrale a portata di pollice" b="Nuovo ticket in 1 tap, sempre sotto al dito destro" />
          <Bullet n="3" t="Bottom nav glassmorfica" b="Home · Tickets · FAB · Emergenze · Insights" />
          <Bullet n="4" t="Swipe gestures (sui ticket)" b="Swipe-left chiude · swipe-right assegna" />
          <Bullet n="5" t="Haptic feedback" b="Vibrazione su submit, errore, conferma" />
        </ul>
      </div>
    </div>
  );
}

const NavBtn = ({ icon: Icon, active, danger }) => (
  <button style={{
    width: 44, height: 44, borderRadius: 12, border: 'none',
    background: active ? `${C.gold}22` : 'transparent',
    display: 'grid', placeItems: 'center', cursor: 'pointer',
  }}>
    <Icon size={20} color={active ? C.gold : danger ? '#FCA5A5' : C.textSec} strokeWidth={active ? 2.4 : 1.8} />
  </button>
);

const MobileTicket = ({ prio, room, cat, title, time, sla }) => (
  <div style={{
    display: 'grid', gridTemplateColumns: '3px 1fr auto', gap: 10,
    padding: '10px 0', background: 'rgba(255,255,255,0.02)', borderRadius: 10,
    border: `1px solid ${C.border}`,
  }}>
    <div style={{ background: prio, borderRadius: 10 }} />
    <div style={{ paddingLeft: 8, minWidth: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
        <span style={{ fontWeight: 600, fontSize: 12 }}>{room}</span>
        <span style={{ fontSize: 10, color: C.textSec }}>· {cat}</span>
        {sla && <span style={{ fontSize: 8.5, color: prio, fontWeight: 700,
                             padding: '1px 5px', background: `${prio}22`, borderRadius: 3 }}>SLA -3m</span>}
      </div>
      <div style={{ fontSize: 11.5, color: C.text,
                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {title}
      </div>
    </div>
    <span style={{ fontSize: 10, color: C.textSec, paddingRight: 12, alignSelf: 'center' }}>{time}</span>
  </div>
);

const Bullet = ({ n, t, b }) => (
  <li style={{ display: 'flex', gap: 14 }}>
    <div style={{
      width: 26, height: 26, borderRadius: 8, background: `${C.gold}22`,
      color: C.gold, fontWeight: 700, fontSize: 12, display: 'grid', placeItems: 'center',
      flexShrink: 0, border: `1px solid ${C.gold}44`,
    }}>{n}</div>
    <div>
      <div style={{ fontSize: 13.5, fontWeight: 600, marginBottom: 3 }}>{t}</div>
      <div style={{ fontSize: 12, color: C.textSec, lineHeight: 1.5 }}>{b}</div>
    </div>
  </li>
);
